export default __webpack_public_path__ + "static/media/SunFilm.a2c8fe64.webp";